export const sortContactsPrimary = (contacts) => {
  const sorted = [...contacts].sort((a, b) => {
    if (a.isPrimary && !b.isPrimary) {
      return -1;
    }
    if (!a.isPrimary && b.isPrimary) {
      return 1;
    }
    const firstNameResult = a.firstName?.localeCompare(b.firstName);
    return firstNameResult !== 0
      ? firstNameResult
      : a.lastName?.localeCompare(b.lastName);
  });

  return sorted;
};
